export default __webpack_public_path__ + "static/economy3-2689eca2476d71ee6b6973ef6f9c5621.png";